import { config, IS_MASTER } from "config";
import * as _ from "lodash";
import { stringify } from "query-string";
import authStore from "stores/AuthStore";
import { debugStore } from "stores/DebugStore";

function nilLog(message?: any, ...optionalParams: any[]) {
    // pass
}

export const logFilter: string | undefined = undefined;

export function log(message?: any, ...optionalParams: any[]) {
    if (!IS_MASTER || config.DEBUG_LOG) {
        if (!logFilter || _.startsWith(message, logFilter)) {
            console.log(message, ...optionalParams);
        }

        if (debugStore.debug) {
            debugStore.pushMessage(message, optionalParams);
        }
    }
}

export function isLocal() {
    // const pathComponents = window.location.href.split("#");
    return _.startsWith(window.location.href, "https://localhost");
}

export function withAccessToken(url: string, queryParams?: any) {
    const ret = url;
    let params;
    if (queryParams) {
        if (typeof queryParams === "string") {
            params = queryParams;
        } else {
            params = stringify(queryParams);
        }
    }

    if (config.DEBUG && authStore.accessToken) {
        return url + "?accessToken=" + authStore.accessToken + (queryParams ? "&" + params : "");
    } else {
        return url + (queryParams ? "?" + params : "");
    }
}


// WEBPACK FOOTER //
// ./src/util/debug.ts